import React, { useState, useEffect, useRef } from "react";
import {
  ArrowLeft,
  Eye,
  ArrowRight,
  Plane,
  Heart,
  MapPin,
  Calendar,
  Camera,
  Star,
  Globe,
  Play,
  Pause,
} from "lucide-react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const VideoAdContent = ({
  isInPreview = false,
  isExpanded = false,
  onExpand,
  onClose,
}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [showControls, setShowControls] = useState(false);
  const videoRef = useRef(null);

  const handlePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleExpand = () => {
    if (onExpand && !isInPreview) {
      onExpand();
    }
  };
  const handleMouseEnter = () => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  };

  const handleMouseLeave = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0; // Reset to start
    }
  };
  return (
    <div
      className={`w-full h-full relative overflow-hidden ${
        isExpanded ? "fixed inset-0 z-50 bg-black" : ""
      }`}
    >
      {!isExpanded ? (
        <div className="relative h-full">
          {/* Compact Video Ad */}
          <div
            className={`relative cursor-pointer transform transition-all duration-300 ${
              !isInPreview ? "hover:scale-105" : ""
            } w-full h-full`}
            onClick={handleExpand}
            onMouseEnter={() => setShowControls(true)}
            onMouseLeave={() => setShowControls(false)}
          >
            {/* Video Container */}
            {/* <div className="relative w-full h-full  overflow-hidden">
              <video
                ref={videoRef}
                className="w-full h-full object-cover"
                muted
                loop
                playsInline
                autoPlay
            
              >
                <source src="/assets/abc.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>

             
              <div className="absolute top-2 left-2 bg-black bg-opacity-60 text-white px-2 py-1 rounded text-xs font-medium">
                AD
              </div>

         
            </div> */}
            <div
              className="relative w-full h-full overflow-hidden group"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <video
                ref={videoRef}
                className="w-full h-full object-cover transition-transform duration-500 ease-in-out  cursor-pointer"
                muted
                loop
                playsInline
              >
                <source src="/assets/abc.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>

              {/* AD Label */}
              <div className="absolute top-2 left-2  bg-opacity-60 text-white px-2 py-1 rounded text-xs font-medium">
                AD
              </div>
            </div>
            {/* Click to expand hint */}
            {/* {!isInPreview && showControls && (
              <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 animate-bounce">
                <div className="bg-black/70 text-white px-3 py-1 rounded-full text-xs whitespace-nowrap">
                  Click to expand!
                </div>
              </div>
            )} */}
          </div>
        </div>
      ) : (
        /* Expanded Video Experience - Full Screen */
        <div className="w-full h-full flex items-center justify-center relative">
          {/* <button
            onClick={onClose}
            className="absolute top-4 right-4 w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white text-xl font-bold transition-all duration-300 hover:scale-110 z-10"
          >
            ×
          </button> */}

          {/* <div className="relative w-full h-full max-w-4xl">
            <video
              ref={videoRef}
              className="w-full h-full object-contain"
              controls
              autoPlay
              muted
              loop
              playsInline
            >
              <source src="/assets/abc.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>

          
          </div> */}
          <div
            className="relative w-full h-full overflow-hidden group"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <video
              ref={videoRef}
              className="w-full h-full object-cover transition-transform duration-500 ease-in-out cursor-pointer"
              muted
              loop
              playsInline
            >
              <source src="/assets/abc.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>

            {/* AD Label */}
            <div className="absolute top-2 left-2 bg-opacity-60 text-white px-2 py-1 rounded text-xs font-medium">
              AD
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

function AbcBeerDetail() {
  const [isMobile, setIsMobile] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
       <Helmet>
       <title>
  ABC Beer Campaign | Drag to Reveal Ad Showcase by Bidbox
        </title>
        <meta
          name="description"
          content="See how ABC Beer engages audiences with Drag to Reveal ads on Bidbox. Explore interactive campaigns that spark curiosity & boost brand impact."
        />
        {/* <meta
          name="keywords"
          content="BidBox AI, Demand-Side Platform, DSP solutions, targeted advertising, ad campaign optimization, programmatic advertising, real-time bidding, ad tech, audience segmentation, AI-driven advertising, digital marketing, performance marketing, cross-channel advertising, ad exchange, ad placement, ad inventory, ad network, data-driven marketing, media buying."
        /> */}
         <link
          rel="canonical"
          href="https://bidbox.ai/drag-to-reveal/abcbeer"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
    </Helmet>
      <div className="min-h-screen bg-gray-50 mt-10">
        <div className="container mx-auto px-4 py-8 lg:py-12">
          <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
            {/* Left column - Content */}
            <div className="flex-1 lg:max-w-lg">
              {/* Header */}
              <header className="animate-slide-up">
                {/* Back to Ad Gallery */}
                <div className="mb-6 lg:mb-8">
                  {/* <button className="flex items-center space-x-2 text-blue-500 hover:text-blue-600 transition-colors duration-200 group">
                  <ArrowLeft className="w-4 h-4 transform group-hover:-translate-x-1 transition-transform duration-200" />
                  <span className="text-sm font-medium">Back to Ad Gallery</span>
                </button> */}
                </div>

                {/* Title and tag */}
                <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
                  <div className="flex flex-wrap items-center gap-3 mb-3">
                    <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                      Drag to Reveal. Launch the Wow.
                    </h1>
                    <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                      Drag to Reveal
                    </span>
                  </div>

                  {/* View in preview site */}
                  {/* <button className="flex items-center space-x-2 text-blue-500 hover:text-blue-600 transition-colors duration-200 group">
                  <Eye className="w-4 h-4" />
                  <span className="text-sm font-medium group-hover:underline">View in preview site</span>
                </button> */}
                </div>
              </header>

              {/* Content Section */}
              <div
                className="animate-slide-up"
                style={{ animationDelay: "0.2s" }}
              >
                {/* Make it yours section */}
                <div className="mb-8">
                  <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
                    MAKE IT YOURS!
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-6 max-w-md">
                    This curtain-drop ad creates a sense of drama and
                    anticipation. Users drag to unveil your latest launch,
                    building curiosity with every move. It’s sleek, interactive,
                    and perfect for spotlighting new products. Just upload your
                    video and brand assets to deliver a reveal experience that
                    feels bold and unforgettable.
                  </p>

                  {/* CTA Button */}
                  <Link to="/contact">
                    <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
                      <span>Start with this Template</span>
                      <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
                    </button>
                  </Link>
                </div>
              </div>
            </div>

            {/* Right column - Template Preview */}
            <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
              {/* Preview toggle */}
              <div
                className="hidden lg:flex justify-center mt-2 animate-fade-in mb-4"
                style={{ animationDelay: "0.3s" }}
              >
                <div className="bg-white rounded-full px-6 py-3 shadow-lg border border-gray-200">
                  <div className="flex items-center space-x-4">
                    {/* <span className="text-sm text-gray-600 font-medium">Preview in:</span> */}
                    <div className="flex items-center space-x-3">
                      <span
                        className={`text-sm font-medium transition-colors ${
                          isMobile ? "text-blue-600" : "text-gray-600"
                        }`}
                      >
                        Mobile
                      </span>
                      <button
                        onClick={() => setIsMobile(!isMobile)}
                        className="relative w-12 h-6 bg-blue-500 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                      >
                        <div
                          className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 ${
                            isMobile ? "left-1" : "left-7"
                          }`}
                        ></div>
                      </button>
                      <span
                        className={`text-sm font-medium transition-colors ${
                          !isMobile ? "text-blue-600" : "text-gray-600"
                        }`}
                      >
                        Desktop
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="relative animate-fade-in"
                style={{ animationDelay: "0.4s" }}
              >
                {/* Mobile Mockup */}
                {isMobile && (
                  <div className="mx-auto max-w-xs">
                    {/* iPhone mockup */}
                    <div className="relative rounded-[2.5rem] p-2 shadow-2xl">
                      {/* Status bar area */}
                      <div className="bg-white rounded-[2rem] overflow-hidden">
                        {/* Status bar */}
                        <div className="bg-white px-6 py-2 flex justify-between items-center text-black text-sm font-medium">
                          <span>9:41</span>
                          <div className="flex items-center space-x-1">
                            <div className="flex space-x-1">
                              <div className="w-1 h-1 bg-black rounded-full"></div>
                              <div className="w-1 h-1 bg-black rounded-full"></div>
                              <div className="w-1 h-1 bg-black rounded-full"></div>
                              <div className="w-1 h-1 bg-black rounded-full"></div>
                            </div>
                            <div className="w-6 h-3 border border-black rounded-sm relative">
                              <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
                            </div>
                          </div>
                        </div>

                        {/* Browser bar */}
                        <div className="bg-gray-100 px-4 py-3 flex items-center space-x-3">
                          <div className="flex-1 bg-white rounded-lg px-3 py-2 text-sm text-gray-600 flex items-center justify-center">
                            publisher.com
                          </div>
                        </div>

                        {/* Content area */}
                        <div className="p-4 bg-gray-50 h-[400px] overflow-y-auto hide-scrollbar">
                          <div className="space-y-3">
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                          </div>
                          {/* Video Ad - Full width on mobile with same gap from top */}
                          <div className="mb-6">
                            <div className="h-48 rounded-lg overflow-hidden">
                              <VideoAdContent
                                isInPreview={true}
                                isExpanded={isExpanded}
                                onExpand={() => setIsExpanded(true)}
                                onClose={() => setIsExpanded(false)}
                              />
                            </div>
                          </div>
                          <div className="space-y-3">
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3 mt-2">
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3 mt-2">
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3 mt-2">
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          {/* Additional content placeholders */}
                          <div className="space-y-3">
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Desktop Mockup */}
                {!isMobile && (
                  <div className="w-full max-w-2xl mx-auto">
                    {/* Desktop Screen Frame */}
                    <div className="bg-gray-200 rounded-xl p-3 shadow-2xl">
                      {/* Screen */}
                      <div
                        className="bg-white rounded-lg overflow-hidden shadow-inner"
                        style={{ aspectRatio: "16/10" }}
                      >
                        {/* macOS-style window header */}
                        <div className="bg-gray-100 px-1 py-1 flex items-center border-b border-gray-200">
                          <div className="flex space-x-2">
                            <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                            <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
                            <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                          </div>
                          <div className="flex-1 mx-6">
                            <div className="bg-white rounded-md px-1 py-1 text-sm text-gray-600 border shadow-sm max-w-md">
                              🔒 publisher.com
                            </div>
                          </div>
                          <div className="flex space-x-1">
                            <div className="w-4 h-4 bg-gray-300 rounded"></div>
                            <div className="w-4 h-4 bg-gray-300 rounded"></div>
                          </div>
                        </div>

                        {/* Browser content area */}
                        <div className="p-1 bg-gray-50 h-[500px] overflow-y-auto hide-scrollbar">
                          {/* Page header */}
                          <div className="mb-2">
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                          </div>

                          {/* Video Ad positioned in content with same gap from top */}
                          <div className="flex justify-center mb-2">
                            <div className="w-80 h-48  overflow-hidden">
                              <VideoAdContent
                                isInPreview={true}
                                isExpanded={isExpanded}
                                onExpand={() => setIsExpanded(true)}
                                onClose={() => setIsExpanded(false)}
                              />
                            </div>
                          </div>
                          {/* Additional content placeholders */}
                          <div className="grid grid-cols-2 gap-6 mb-6 mt-2">
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                            <div className="space-y-3 mt-2">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                          </div>

                          {/* Sidebar placeholders */}
                          <div className="grid grid-cols-3 gap-4">
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                          </div>
                          <div className="grid grid-cols-2 gap-6 mb-6">
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                          </div>

                          {/* Sidebar placeholders */}
                          <div className="grid grid-cols-3 gap-4">
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                          </div>
                          {/* Additional content placeholders */}
                          <div className="grid grid-cols-2 gap-6 mb-6">
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                          </div>

                          {/* Sidebar placeholders */}
                          <div className="grid grid-cols-3 gap-4">
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Monitor stand */}
                    <div className="flex justify-center">
                      <div className="w-20 h-4 bg-gray-200 rounded-b-lg"></div>
                    </div>
                    <div className="flex justify-center">
                      <div className="w-32 h-2 bg-gray-300 rounded-full"></div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Expanded Video Overlay */}
        {isExpanded && (
          <div className="fixed inset-0 z-50">
            <VideoAdContent
              isExpanded={true}
              onClose={() => setIsExpanded(false)}
            />
          </div>
        )}

        <style jsx>{`
          @keyframes slide-up {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes fade-in {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }

          .animate-slide-up {
            animation: slide-up 0.6s ease-out forwards;
          }

          .animate-fade-in {
            animation: fade-in 0.6s ease-out forwards;
          }
        `}</style>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-10">
        <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">
          Discover More Ads
        </h1>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {/* Card 1 */}
          <Link
            to="/gamification/samsung"
            className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl"
          >
            <img
              src="/assets/sama.jpg"
              alt="Card 1"
              className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
              <h2 className="text-lg font-semibold">Samsung</h2>
            </div>
          </Link>

          {/* Card 2 */}
          <Link
            to="/video/mollers"
            className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl"
          >
            <img
              src="/assets/moll.avif"
              alt="Card 2"
              className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
              <h2 className="text-lg font-semibold">Mollers</h2>
            </div>
          </Link>

          {/* Card 3 */}
          <Link
            to="/video/tiger"
            className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl"
          >
            <img
              src="/assets/tiger.avif"
              alt="Card 3"
              className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
              <h2 className="text-lg font-semibold">Tiger</h2>
            </div>
          </Link>

          {/* Card 4 */}
          <Link
            to="/tap-to-reveal/ps"
            className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl"
          >
            <img
              src="assets/ps.avif"
              alt="Card 4"
              className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
              <h2 className="text-lg font-semibold">PS5 </h2>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
}

export default AbcBeerDetail;

// import React, { useState, useRef, useEffect } from 'react';
// import { ChevronLeft, ChevronRight, Copy, X, RotateCcw, Menu, Heart, Share2, Bookmark, Eye } from 'lucide-react';

// export default function AbcBeerDetail() {
//   const [selectedCreative, setSelectedCreative] = useState(0);
//   const [isDragging, setIsDragging] = useState(false);
//   const [dragOffset, setDragOffset] = useState(0);
//   const [isRevealed, setIsRevealed] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const dragRef = useRef(null);
//   const startPos = useRef(0);

//   const creatives = [
//     {
//       title: '2024_11_ABC_RN_RM_Standard_300x250_v7_300x250',
//       dimension: '300x250',
//       type: 'Banner - Javascript tag',
//       src: '/assets/abc.mp4',
//       likes: 234,
//       views: 1420
//     },
//     {
//       title: '2024_11_ABC_RN_RM_Standard_300x600_v7_300x600',
//       dimension: '300x600',
//       type: 'Banner - Javascript tag',
//       src: '/assets/abc.mp4',
//       likes: 189,
//       views: 890
//     },
//     {
//       title: '2024_11_ABC_RN_RM_Standard_320x480_v7_320x480',
//       dimension: '320x480',
//       type: 'Banner - Javascript tag',
//       src: '/assets/abc.mp4',
//       likes: 156,
//       views: 673
//     },
//   ];

//   useEffect(() => {
//     const checkMobile = () => {
//       setIsMobile(window.innerWidth < 768);
//     };

//     checkMobile();
//     window.addEventListener('resize', checkMobile);
//     return () => window.removeEventListener('resize', checkMobile);
//   }, []);

//   const handlePrev = () => {
//     setSelectedCreative((prev) => (prev === 0 ? creatives.length - 1 : prev - 1));
//   };

//   const handleNext = () => {
//     setSelectedCreative((prev) => (prev === creatives.length - 1 ? 0 : prev + 1));
//   };

//   const handleDragStart = (e) => {
//     setIsDragging(true);
//     startPos.current = e.type === 'mousedown' ? e.clientX : e.touches[0].clientX;
//   };

//   const handleDragMove = (e) => {
//     if (!isDragging) return;

//     const currentPos = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
//     const diff = currentPos - startPos.current;

//     if (diff > 0 && diff < 200) {
//       setDragOffset(diff);
//     }

//     if (diff > 150) {
//       setIsRevealed(true);
//       setIsDragging(false);
//       setDragOffset(0);
//     }
//   };

//   const handleDragEnd = () => {
//     if (dragOffset < 150) {
//       setDragOffset(0);
//     }
//     setIsDragging(false);
//   };

//   const currentCreative = creatives[selectedCreative];

//   const MobileView = () => (
//     <div className="min-h-screen bg-gradient-to-br from-amber-50 to-orange-100">
//       {/* Mobile Header */}
//       <header className="bg-gradient-to-r from-amber-600 to-orange-600 p-4 text-white shadow-lg">
//         <div className="flex items-center justify-between">
//           <div className="flex items-center space-x-3">
//             <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
//               <span className="text-amber-600 font-bold text-sm">🍺</span>
//             </div>
//             <h1 className="font-bold text-lg">ABC Beer</h1>
//           </div>
//           <Menu className="w-6 h-6" />
//         </div>
//       </header>

//       {/* Mobile Creative Selector */}
//       <div className="p-4 bg-white shadow-sm">
//         <div className="flex items-center justify-between mb-3">
//           <h2 className="font-semibold text-gray-800">Creative Preview</h2>
//           <div className="flex items-center space-x-2 text-sm text-gray-600">
//             <Eye className="w-4 h-4" />
//             <span>{currentCreative.views}</span>
//           </div>
//         </div>

//         <div className="flex space-x-2 overflow-x-auto pb-2">
//           {creatives.map((creative, index) => (
//             <button
//               key={index}
//               onClick={() => setSelectedCreative(index)}
//               className={`flex-shrink-0 px-3 py-2 rounded-full text-xs font-medium transition-all ${
//                 selectedCreative === index
//                   ? 'bg-amber-600 text-white shadow-md'
//                   : 'bg-gray-200 text-gray-600 hover:bg-gray-300'
//               }`}
//             >
//               {creative.dimension}
//             </button>
//           ))}
//         </div>
//       </div>

//       {/* Mobile Ad Preview */}
//       <div className="p-4">
//         <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
//           {/* Drag to Reveal Area */}
//           <div className="relative bg-gradient-to-r from-amber-500 to-orange-500 p-6 text-white overflow-hidden">
//             <div
//               className={`absolute inset-0 bg-gradient-to-r from-amber-600 to-orange-600 transition-transform duration-300 ${
//                 isRevealed ? 'transform translate-x-full' : ''
//               }`}
//               style={{ transform: `translateX(${dragOffset}px)` }}
//             ></div>

//             <div
//               className="relative z-10 cursor-grab active:cursor-grabbing select-none"
//               onMouseDown={handleDragStart}
//               onMouseMove={handleDragMove}
//               onMouseUp={handleDragEnd}
//               onTouchStart={handleDragStart}
//               onTouchMove={handleDragMove}
//               onTouchEnd={handleDragEnd}
//               ref={dragRef}
//             >
//               <div className="flex items-center justify-between">
//                 <div>
//                   <h3 className="font-bold text-lg mb-1">Drag to Reveal</h3>
//                   <p className="text-amber-100 text-sm">Swipe right to see the magic ✨</p>
//                 </div>
//                 <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
//                   <ChevronRight className="w-6 h-6 animate-pulse" />
//                 </div>
//               </div>
//             </div>

//             {/* Revealed Content */}
//             <div className={`absolute inset-0 bg-gradient-to-r from-green-500 to-emerald-500 flex items-center justify-center transition-all duration-500 ${
//               isRevealed ? 'opacity-100' : 'opacity-0 pointer-events-none'
//             }`}>
//               <div className="text-center">
//                 <Heart className="w-12 h-12 mx-auto mb-2 text-white fill-current animate-bounce" />
//                 <p className="font-bold text-xl">Awesome!</p>
//                 <p className="text-green-100">You revealed the secret! 🎉</p>
//               </div>
//             </div>
//           </div>

//           {/* Ad Frame */}
//           <div className="p-4 bg-gray-50">
//             <div className="flex items-center justify-between mb-4">
//               <button onClick={handlePrev} className="flex items-center space-x-1 text-amber-600 font-medium">
//                 <ChevronLeft className="w-4 h-4" />
//                 <span className="text-sm">Prev</span>
//               </button>

//               <div className="text-center">
//                 <p className="font-medium text-gray-800 text-sm">{currentCreative.dimension}</p>
//                 <p className="text-xs text-gray-500">{currentCreative.type}</p>
//               </div>

//               <button onClick={handleNext} className="flex items-center space-x-1 text-amber-600 font-medium">
//                 <span className="text-sm">Next</span>
//                 <ChevronRight className="w-4 h-4" />
//               </button>
//             </div>

//             <div className="flex justify-center">
//               <div className="relative">
//                 <iframe
//                   title="Ad Preview"
//                   src={currentCreative.src}
//                   width={Math.min(300, window.innerWidth - 80)}
//                   height={Math.min(250, (window.innerWidth - 80) * 0.83)}
//                   className="border-2 border-gray-200 rounded-lg shadow-md"
//                 ></iframe>
//                 <div className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 rounded-full flex items-center justify-center">
//                   <span className="text-white text-xs font-bold">🔥</span>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Mobile Actions */}
//           <div className="p-4 bg-white border-t border-gray-100">
//             <div className="flex items-center justify-between">
//               <div className="flex items-center space-x-4">
//                 <button className="flex items-center space-x-1 text-gray-600 hover:text-red-500 transition-colors">
//                   <Heart className="w-5 h-5" />
//                   <span className="text-sm font-medium">{currentCreative.likes}</span>
//                 </button>
//                 <button className="flex items-center space-x-1 text-gray-600 hover:text-blue-500 transition-colors">
//                   <Share2 className="w-5 h-5" />
//                   <span className="text-sm">Share</span>
//                 </button>
//                 <button className="flex items-center space-x-1 text-gray-600 hover:text-amber-500 transition-colors">
//                   <Bookmark className="w-5 h-5" />
//                   <span className="text-sm">Save</span>
//                 </button>
//               </div>
//               <button className="flex items-center space-x-1 text-amber-600 hover:text-amber-700 transition-colors">
//                 <RotateCcw className="w-4 h-4" />
//                 <span className="text-sm font-medium">Reload</span>
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Mobile Creative Details */}
//       <div className="p-4">
//         <div className="bg-white rounded-xl shadow-lg p-4">
//           <h3 className="font-bold text-lg mb-3 text-gray-800">Creative Details</h3>
//           <div className="space-y-2">
//             <div className="flex justify-between">
//               <span className="text-gray-600">Dimension:</span>
//               <span className="font-medium text-gray-800">{currentCreative.dimension}</span>
//             </div>
//             <div className="flex justify-between">
//               <span className="text-gray-600">Type:</span>
//               <span className="font-medium text-gray-800">{currentCreative.type}</span>
//             </div>
//             <div className="flex justify-between">
//               <span className="text-gray-600">Engagement:</span>
//               <span className="font-medium text-green-600">High</span>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   const DesktopView = () => (
//     <div className="flex flex-col min-h-screen bg-gradient-to-br from-slate-50 to-gray-100 mt-14">
//       {/* Desktop Header */}
//       {/* <header className="flex items-center justify-between bg-gradient-to-r from-blue-600 to-indigo-600 p-4 text-white shadow-lg">
//         <div className="flex items-center space-x-4">
//           <div className="flex items-center space-x-3">
//             <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
//               <span className="text-blue-600 font-bold">🍺</span>
//             </div>
//             <h1 className="text-xl font-bold">ABC Beer Creative Studio</h1>
//           </div>
//           <nav className="flex space-x-6 ml-8">
//             <a href="#" className="hover:text-blue-200 transition-colors">Programmatic Blog</a>
//             <a href="#" className="hover:text-blue-200 transition-colors">Ad Gallery</a>
//             <a href="#" className="hover:text-blue-200 transition-colors">Manual</a>
//             <a href="#" className="hover:text-blue-200 transition-colors">Book Demo</a>
//           </nav>
//         </div>
//         <div className="flex items-center space-x-3">
//           <button className="bg-white/20 hover:bg-white/30 px-4 py-2 rounded-lg transition-colors">
//             Sign In
//           </button>
//         </div>
//       </header> */}

//       {/* Desktop Main Content */}
//       <div className="flex flex-1">
//         {/* Left Sidebar */}
//         <div className="w-80 bg-white shadow-lg p-6">
//           <div className="flex items-center justify-between mb-6">
//             <h2 className="font-bold text-xl text-gray-800">Creatives</h2>
//             <div className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">
//               {creatives.length} Items
//             </div>
//           </div>

//           <div className="space-y-3">
//             {creatives.map((creative, index) => (
//               <div
//                 key={index}
//                 className={`p-4 rounded-xl cursor-pointer transition-all duration-200 hover:shadow-md ${
//                   selectedCreative === index
//                     ? 'bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-blue-200 shadow-md'
//                     : 'bg-gray-50 hover:bg-gray-100 border-2 border-transparent'
//                 }`}
//                 onClick={() => setSelectedCreative(index)}
//               >
//                 <div className="flex items-center justify-between mb-2">
//                   <h3 className="font-semibold text-gray-800 text-sm">{creative.dimension}</h3>
//                   <div className={`w-3 h-3 rounded-full ${selectedCreative === index ? 'bg-blue-500' : 'bg-gray-300'}`}></div>
//                 </div>
//                 <p className="text-xs text-gray-600 mb-1">Type: {creative.type}</p>
//                 <div className="flex items-center justify-between text-xs text-gray-500">
//                   <div className="flex items-center space-x-1">
//                     <Heart className="w-3 h-3" />
//                     <span>{creative.likes}</span>
//                   </div>
//                   <div className="flex items-center space-x-1">
//                     <Eye className="w-3 h-3" />
//                     <span>{creative.views}</span>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Center Preview */}
//         <div className="flex-1 flex flex-col items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200 p-8">
//           {/* Drag to Reveal Section */}
//           <div className="mb-8 w-full max-w-2xl">
//             <div className="relative bg-gradient-to-r from-amber-500 to-orange-500 rounded-2xl p-8 text-white overflow-hidden shadow-xl">
//               <div
//                 className={`absolute inset-0 bg-gradient-to-r from-amber-600 to-orange-600 transition-transform duration-500 ${
//                   isRevealed ? 'transform translate-x-full' : ''
//                 }`}
//                 style={{ transform: `translateX(${dragOffset}px)` }}
//               ></div>

//               <div
//                 className="relative z-10 cursor-grab active:cursor-grabbing select-none"
//                 onMouseDown={handleDragStart}
//                 onMouseMove={handleDragMove}
//                 onMouseUp={handleDragEnd}
//                 ref={dragRef}
//               >
//                 <div className="flex items-center justify-between">
//                   <div>
//                     <h3 className="font-bold text-2xl mb-2">✨ Drag to Reveal Magic</h3>
//                     <p className="text-amber-100">Click and drag right to unlock something special!</p>
//                   </div>
//                   <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center">
//                     <ChevronRight className="w-8 h-8 animate-pulse" />
//                   </div>
//                 </div>
//               </div>

//               {/* Revealed Content */}
//               <div className={`absolute inset-0 bg-gradient-to-r from-green-500 to-emerald-500 flex items-center justify-center transition-all duration-500 ${
//                 isRevealed ? 'opacity-100' : 'opacity-0 pointer-events-none'
//               }`}>
//                 <div className="text-center">
//                   <Heart className="w-16 h-16 mx-auto mb-4 text-white fill-current animate-bounce" />
//                   <h3 className="font-bold text-3xl mb-2">Fantastic!</h3>
//                   <p className="text-green-100 text-lg">You've unlocked the creative spirit! 🎉</p>
//                   <button
//                     onClick={() => setIsRevealed(false)}
//                     className="mt-4 bg-white/20 hover:bg-white/30 px-6 py-2 rounded-lg transition-colors"
//                   >
//                     Try Again
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Ad Preview Navigation */}
//           <div className="flex justify-between w-full max-w-4xl mb-6">
//             <button
//               onClick={handlePrev}
//               className="flex items-center space-x-2 text-blue-600 hover:text-blue-700 font-medium bg-white px-6 py-3 rounded-lg shadow-md hover:shadow-lg transition-all"
//             >
//               <ChevronLeft className="w-5 h-5" />
//               <span>Previous Creative</span>
//             </button>

//             <div className="flex items-center space-x-3 bg-white px-6 py-3 rounded-lg shadow-md">
//               <h3 className="font-semibold text-gray-800">{currentCreative.title}</h3>
//               <Copy className="cursor-pointer text-gray-500 hover:text-gray-700 transition-colors w-5 h-5" />
//             </div>

//             <button
//               onClick={handleNext}
//               className="flex items-center space-x-2 text-blue-600 hover:text-blue-700 font-medium bg-white px-6 py-3 rounded-lg shadow-md hover:shadow-lg transition-all"
//             >
//               <span>Next Creative</span>
//               <ChevronRight className="w-5 h-5" />
//             </button>
//           </div>

//           {/* Ad Frame */}
//           <div className="relative bg-white p-8 rounded-2xl shadow-xl">
//             <iframe
//               title="Ad Preview"
//               src={currentCreative.src}
//               width={currentCreative.dimension.split('x')[0]}
//               height={currentCreative.dimension.split('x')[1]}
//               className="border-2 border-gray-200 rounded-lg shadow-md"
//             ></iframe>
//             <div className="absolute -top-3 -right-3 w-8 h-8 bg-red-500 rounded-full flex items-center justify-center animate-pulse">
//               <span className="text-white text-sm font-bold">🔥</span>
//             </div>
//           </div>

//           <button className="mt-6 text-blue-600 hover:text-blue-700 flex items-center space-x-2 bg-white px-6 py-3 rounded-lg shadow-md hover:shadow-lg transition-all">
//             <RotateCcw className="w-5 h-5" />
//             <span className="font-medium">Reload Creative</span>
//           </button>
//         </div>

//         {/* Right Sidebar */}
//         <div className="w-80 bg-white shadow-lg p-6">
//           <h2 className="font-bold text-xl mb-6 text-gray-800">Creative Analytics</h2>

//           <div className="space-y-6">
//             <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-4 rounded-xl">
//               <h3 className="font-semibold text-gray-800 mb-3">Details</h3>
//               <div className="space-y-2">
//                 <div className="flex justify-between">
//                   <span className="text-gray-600">Dimension:</span>
//                   <span className="font-medium text-gray-800">{currentCreative.dimension}</span>
//                 </div>
//                 <div className="flex justify-between">
//                   <span className="text-gray-600">Type:</span>
//                   <span className="font-medium text-gray-800">{currentCreative.type}</span>
//                 </div>
//               </div>
//             </div>

//             <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-4 rounded-xl">
//               <h3 className="font-semibold text-gray-800 mb-3">Performance</h3>
//               <div className="space-y-3">
//                 <div className="flex items-center justify-between">
//                   <div className="flex items-center space-x-2">
//                     <Heart className="w-4 h-4 text-red-500" />
//                     <span className="text-gray-600">Likes</span>
//                   </div>
//                   <span className="font-bold text-red-500">{currentCreative.likes}</span>
//                 </div>
//                 <div className="flex items-center justify-between">
//                   <div className="flex items-center space-x-2">
//                     <Eye className="w-4 h-4 text-blue-500" />
//                     <span className="text-gray-600">Views</span>
//                   </div>
//                   <span className="font-bold text-blue-500">{currentCreative.views}</span>
//                 </div>
//               </div>
//             </div>

//             <div className="flex space-x-2">
//               <button className="flex-1 bg-gradient-to-r from-blue-500 to-indigo-500 text-white py-3 rounded-lg font-medium hover:from-blue-600 hover:to-indigo-600 transition-all shadow-md">
//                 Download
//               </button>
//               <button className="flex-1 bg-gradient-to-r from-green-500 to-emerald-500 text-white py-3 rounded-lg font-medium hover:from-green-600 hover:to-emerald-600 transition-all shadow-md">
//                 Share
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   return isMobile ? <MobileView /> : <DesktopView />;
// }
